module.exports = __webpack_public_path__ + "img/des_jita_03.e5e853c8.jpg";